import { Modal, Row, Col, Alert } from "react-bootstrap";
import PortalService from '../../../services/portal.service';
import { useContext, useEffect, useState } from "react";
import StateContext from '../../../context/State';
import { VerifiedClient } from '../../../types';
import React from 'react';
import { useAppSelector } from '../../../../../redux/hooks';
import { ReducerEnum, setClientPortalModalType } from '../../../../../redux/reducer';
import IDV from './IDV';
import { runInnerFunction } from "../../../../../compatManager";


export type IdentityVerificationTaskModalProps = {
    dispatch: (arg0: {
        type: ReducerEnum;
        payload: any;
        key?: string;
        extraPayload?: Record<string, string>;
    }) => void;
}

const IdentityVerificationTaskModal = (props: IdentityVerificationTaskModalProps) => {

    const { state } = useContext(StateContext);
    const lawyerService = new PortalService(state);

    const [verificationData, setVerificationData] = useState<VerifiedClient[]>([]);

    const show: boolean = useAppSelector((state) => state.ClientPortalState?.ModalType === 'idverification');

    // eslint-disable-next-line
    useEffect(() => { getIdentityVerificationData(); }, [show])
    const getIdentityVerificationData = async () => {
        try {
            if (!show) return;
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            const requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: JSON.stringify({
                    "Appid": state.appId,
                    "Product": lawyerService.getSessionAppCode()
                })
            };
            fetch(`/${process.env.REACT_APP_MOBILE_ENDPOINT}/api/getTableRecords?SessionID=${lawyerService.getSessionId()}&compat=1`, requestOptions)
                .then(response => response.text())
                .then(result => {
                    setVerificationData(parseGetTableRecords(result));
                })
                .catch(error => console.log('error', error));
        } catch (err) {
            console.log(err);
        }
    };

    const parseGetTableRecords = (result: string): VerifiedClient[] => {
        if (result.includes('Detailed Error - 404.0 - Not Found')) { return [] }

        const xmlData = result;
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(JSON.parse(xmlData).result, "text/xml");
        const EntityList = xmlDoc.getElementsByTagName('Entity');
        const data: VerifiedClient[] = [];
        for (let i = 0; i < EntityList.length; i++) {
            data.push(parseTableRecord(EntityList[i]));
        }
        return data;
    };

    const parseTableRecord = (Entity: Element): VerifiedClient => {
        const clientInformation = mappingAttribute(Entity) as VerifiedClient["clientInformation"];
        const clientIDImages = mappingAttribute(Entity.childNodes[0] as Element) as VerifiedClient["clientIDImages"];
        const clientIdFraudCheck = mappingAttribute(Entity.childNodes[0].childNodes[0] as Element) as VerifiedClient["clientIdFraudCheck"];
        return { Entity: Entity.outerHTML, clientInformation, clientIDImages, clientIdFraudCheck };

        function mappingAttribute(node: Element) {
            const ret = {};
            for (let i = 0; i < node.attributes.length; i++) {
                const attributeName = node.attributes[i].name;
                ret[attributeName] = node.getAttribute(attributeName);
            }
            return ret;
        }
    };

    let setPageDirtyOnClose = false;
    const setDirty = () => { setPageDirtyOnClose = true; }
    const CloseHandler = () => {
        props.dispatch(setClientPortalModalType(''));
        if (setPageDirtyOnClose) {
            runInnerFunction("SetPageDirty", null);
        }
    }

    return (
        show &&
        <Modal
            show={show}
            onHide={CloseHandler}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter" >Submitted Verifications</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Row>
                    <Col>
                        {
                            verificationData.length !== 0 ?
                                <>
                                    {verificationData.map((verifiedClient: VerifiedClient, index) => {
                                        return (
                                            <IDV idv={verifiedClient} setDirty={setDirty} key={verifiedClient.clientInformation.Name + "-fragment-" + index} />
                                        )
                                    })}
                                </>
                                :
                                <Alert>No Clients have used the ClientConnect App to identify themselves.</Alert>
                        }
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    );
}

export default IdentityVerificationTaskModal;
